var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTicketNotWin = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 88,
  height: 85,
  viewBox: "0 0 88 85",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.7666 21.4114L12.2099 70.4714C12.8149 74.9814 15.7666 77.6764 20.4966 77.8964L74.0849 70.4531C78.8149 70.6548 82.8116 67.6664 82.9949 63.7798L84.3516 23.9048C84.5166 20.0364 80.7949 16.6998 76.0649 16.4798L13.6583 14.7381C8.92827 14.5364 4.9316 17.5431 4.7666 21.4114Z",
  fill: "url(#paint0_linear_20693_10424)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M84.2599 49.4982L79.8783 40.7715C79.7133 40.8999 79.53 41.0099 79.3283 41.1015C76.0283 42.7699 71.2249 39.9099 68.6216 34.7215C66.0183 29.5332 66.5866 23.9965 69.8866 22.3282C70.07 22.2365 70.2716 22.1449 70.4733 22.0899L66.7149 14.6099L20.8633 37.6732L38.3899 72.5615L84.2599 49.4982Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.4917 43.7234L8.87337 52.4501C9.03837 52.3217 9.2217 52.2117 9.42337 52.1201C12.7234 50.4517 17.5267 53.3117 20.13 58.5001C22.7334 63.6884 22.165 69.2251 18.865 70.8934C18.6817 70.9851 18.48 71.0767 18.2784 71.1317L22.0367 78.6117L37.675 70.7467L20.1484 35.8584L4.4917 43.7234Z",
  fill: "#FF5AAD"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M53.9133 54.1618L50.3336 54.38L49.3513 31.6506L52.9047 31.4457L53.9133 54.1618ZM44.7775 47.3893C41.8586 48.8564 38.4081 47.9555 36.8088 44.7735C35.3681 41.9072 36.3085 38.4698 39.4905 36.8705C42.4357 35.3901 45.873 36.2648 47.4591 39.4204C48.913 42.3131 47.9858 45.7767 44.7775 47.3893ZM43.4292 44.6412C44.7966 43.9539 45.1224 42.3737 44.4351 41.0062C43.6817 39.5073 42.1801 39.0103 40.9178 39.6448C39.5767 40.3188 39.2247 41.9122 39.912 43.2797C40.6522 44.7523 42.1932 45.2624 43.4292 44.6412ZM63.5762 48.745C60.6573 50.2121 57.2068 49.3112 55.6207 46.1555C54.1668 43.2629 55.1073 39.8255 58.2892 38.2262C61.2344 36.7458 64.6849 37.6468 66.271 40.8024C67.7249 43.6951 66.7845 47.1324 63.5762 48.745ZM62.2279 45.9969C63.5953 45.3095 63.9211 43.7294 63.2338 42.3619C62.4936 40.8893 60.992 40.3923 59.7298 41.0267C58.3623 41.7141 58.0234 43.2679 58.7107 44.6354C59.4509 46.108 60.9657 46.6313 62.2279 45.9969Z",
  fill: "#FF5AAD"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M67.079 8.62598L74.2174 22.8188L72.8734 24.4917C71.0504 26.7608 70.6086 29.9833 71.9903 32.7859C73.3996 35.5528 76.2486 37.1168 79.1744 37.0142L81.3121 36.9392L88.4482 51.1274L21.363 84.851L14.1818 70.5996L15.4265 68.9431C17.133 66.6721 17.5099 63.5336 16.1574 60.8413L16.156 60.8385L16.1546 60.8357C14.8057 58.1379 12.0793 56.5811 9.21816 56.5939L7.15221 56.6033L-0.0292969 42.3512L67.079 8.62598ZM8.93888 45.3149L11.3347 50.0696C15.816 50.722 19.9324 53.4668 22.124 57.8484C24.3091 62.2009 24.0696 67.149 21.9259 71.1341L24.3233 75.8917L79.4848 48.1621L77.1857 43.5909C72.5687 43.0357 68.2955 40.2607 66.0295 35.7904L66.0226 35.7768L66.0158 35.763C63.7986 31.2876 64.0944 26.1995 66.4118 22.1554L64.1139 17.5868L8.93888 45.3149Z",
  fill: "url(#paint1_linear_20693_10424)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.9674 59.4717C33.7291 58.5877 35.8738 59.2991 36.7578 61.0607L36.9159 61.3758C36.9693 61.4821 37.0168 61.5899 37.0587 61.6986C37.1208 61.7972 37.1788 61.8997 37.2322 62.006L37.5484 62.6362C37.6018 62.7426 37.6493 62.8503 37.6912 62.959C37.7533 63.0576 37.8113 63.1601 37.8647 63.2664L38.1809 63.8966C38.2343 64.003 38.2818 64.1107 38.3237 64.2195C38.3858 64.318 38.4438 64.4205 38.4972 64.5269L38.8134 65.1571C38.8668 65.2634 38.9143 65.3711 38.9562 65.4799C39.0183 65.5784 39.0763 65.6809 39.1297 65.7873L39.2878 66.1024C40.1718 67.864 39.4603 70.0087 37.6987 70.8927C35.9371 71.7767 33.7924 71.0653 32.9084 69.3037L32.7503 68.9886C32.6969 68.8822 32.6494 68.7745 32.6075 68.6657C32.5453 68.5672 32.4874 68.4647 32.434 68.3583L32.1178 67.7281C32.0644 67.6218 32.0169 67.5141 31.975 67.4053C31.9128 67.3068 31.8549 67.2043 31.8015 67.0979L31.4853 66.4677C31.4319 66.3614 31.3844 66.2537 31.3425 66.1449C31.2803 66.0463 31.2224 65.9438 31.169 65.8375L30.8528 65.2073C30.7994 65.101 30.7519 64.9932 30.71 64.8845C30.6478 64.7859 30.5899 64.6834 30.5365 64.5771L30.3784 64.262C29.4944 62.5004 30.2058 60.3557 31.9674 59.4717Z",
  fill: "url(#paint2_linear_20693_10424)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.6139 48.8203C28.3755 47.9363 30.5202 48.6477 31.4043 50.4093L31.5624 50.7244C31.6157 50.8308 31.6633 50.9385 31.7051 51.0473C31.7673 51.1458 31.8253 51.2483 31.8786 51.3547L32.1949 51.9849C32.2482 52.0912 32.2958 52.1989 32.3376 52.3077C32.3998 52.4062 32.4578 52.5087 32.5111 52.6151L32.8274 53.2453C32.8807 53.3516 32.9283 53.4593 32.9701 53.5681C33.0323 53.6667 33.0903 53.7692 33.1436 53.8755L33.4599 54.5057C33.5132 54.612 33.5608 54.7197 33.6026 54.8285C33.6648 54.9271 33.7228 55.0296 33.7761 55.1359L33.9343 55.451C34.8183 57.2126 34.1068 59.3573 32.3452 60.2413C30.5836 61.1253 28.4389 60.4139 27.5549 58.6523L27.3968 58.3372C27.3434 58.2309 27.2959 58.1231 27.254 58.0144C27.1918 57.9158 27.1339 57.8133 27.0805 57.707L26.7643 57.0768C26.7109 56.9704 26.6634 56.8627 26.6215 56.754C26.5593 56.6554 26.5014 56.5529 26.448 56.4466L26.1318 55.8164C26.0784 55.71 26.0309 55.6023 25.989 55.4935C25.9268 55.395 25.8689 55.2925 25.8155 55.1861L25.4993 54.5559C25.4459 54.4496 25.3984 54.3419 25.3565 54.2331C25.2943 54.1346 25.2364 54.0321 25.183 53.9257L25.0249 53.6106C24.1409 51.849 24.8523 49.7043 26.6139 48.8203Z",
  fill: "url(#paint3_linear_20693_10424)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.2609 38.187C23.0225 37.303 25.1672 38.0144 26.0512 39.776L26.2094 40.0911C26.2627 40.1975 26.3103 40.3052 26.3521 40.414C26.4143 40.5125 26.4722 40.615 26.5256 40.7214L26.8419 41.3516C26.8952 41.4579 26.9428 41.5656 26.9846 41.6744C27.0468 41.7729 27.1047 41.8754 27.1581 41.9818L27.4744 42.612C27.5277 42.7183 27.5753 42.826 27.6171 42.9348C27.6793 43.0333 27.7372 43.1359 27.7906 43.2422L28.1069 43.8724C28.1602 43.9787 28.2078 44.0864 28.2496 44.1952C28.3118 44.2938 28.3697 44.3963 28.4231 44.5026L28.5812 44.8177C29.4652 46.5793 28.7538 48.724 26.9922 49.608C25.2306 50.492 23.0859 49.7806 22.2019 48.019L22.0437 47.7039C21.9904 47.5976 21.9428 47.4898 21.901 47.3811C21.8388 47.2825 21.7808 47.18 21.7275 47.0737L21.4112 46.4435C21.3579 46.3371 21.3103 46.2294 21.2685 46.1207C21.2063 46.0221 21.1483 45.9196 21.095 45.8133L20.7787 45.1831C20.7254 45.0767 20.6778 44.969 20.636 44.8602C20.5738 44.7617 20.5158 44.6592 20.4625 44.5528L20.1462 43.9226C20.0929 43.8163 20.0453 43.7086 20.0035 43.5998C19.9413 43.5013 19.8833 43.3988 19.83 43.2924L19.6719 42.9773C18.7878 41.2157 19.4993 39.071 21.2609 38.187Z",
  fill: "url(#paint4_linear_20693_10424)"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.7764 11.3459L54.6514 10.5209L55.1645 7.95508L59.2895 8.78008L58.7764 11.3459Z",
  fill: "#AC41D8"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M72.6479 12.1673L76.8463 11.9106L77.006 14.5224L72.8076 14.779L72.6479 12.1673Z",
  fill: "#AC41D8"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M69.7236 6.58895L73.1886 4.16895L74.6869 6.31415L71.2219 8.73415L69.7236 6.58895Z",
  fill: "#AC41D8"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.2718 5.36228L60.8784 1.38395L63.3479 0.519043L64.7413 4.49738L62.2718 5.36228Z",
  fill: "#AC41D8"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20693_10424",
  x1: 5.83881,
  y1: 80.6313,
  x2: 86.8301,
  y2: -0.360076,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00D38D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1631,
  stopColor: "#00CA87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4244,
  stopColor: "#00B375"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7495,
  stopColor: "#008D59"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006B3F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_20693_10424",
  x1: 11.6007,
  y1: 63.1419,
  x2: 76.8264,
  y2: 30.3575,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC41D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0770749,
  stopColor: "#A641D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4555,
  stopColor: "#8E40B2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7765,
  stopColor: "#7E3F9F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#793F98"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_20693_10424",
  x1: 32.6539,
  y1: 66.2873,
  x2: 37.0117,
  y2: 64.0969,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC41D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0770749,
  stopColor: "#A641D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4555,
  stopColor: "#8E40B2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7765,
  stopColor: "#7E3F9F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#793F98"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_20693_10424",
  x1: 27.3026,
  y1: 55.6415,
  x2: 31.6605,
  y2: 53.4511,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC41D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0770749,
  stopColor: "#A641D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4555,
  stopColor: "#8E40B2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7765,
  stopColor: "#7E3F9F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#793F98"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_20693_10424",
  x1: 21.9519,
  y1: 44.9955,
  x2: 26.3098,
  y2: 42.8051,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC41D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0770749,
  stopColor: "#A641D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4555,
  stopColor: "#8E40B2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7765,
  stopColor: "#7E3F9F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#793F98"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTicketNotWin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ticket-not-win.50d4a335d9317d03a384fccdc1c1f78c.svg";